export enum EComboItemType {
  Meal = 0,
  Drink = 1,
}
